import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as SettingLayout } from 'src/layouts/setting';

const IndexPage = lazy(() => import('src/pages/dashboard/index'));
const ContactPage = lazy(() => import('src/pages/dashboard/contact'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <SettingLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </SettingLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
    ],
  },

];
